/**
 * Clarity enrichment (config: snippets/fitaz-clarity-enrich.liquid).
 *
 * Adds what Clarity cannot see on its own:
 *   events   atc_click / atc_success / atc_fail / atc_no_response, cart_remove,
 *            drawer_open, drawer_checkout_click, cart_page_checkout_click,
 *            checkout_nav_slow, upsell_add, loop_checkout_click,
 *            popup_view / popup_close / popup_cta, quiz_start, quiz_result_view,
 *            quiz_result_cta, js_error
 *   tags     fz_* market, page, in-app browser, screen height, ad + campaign,
 *            customer state, cart contents, last ATC error
 *   identify hashed customer id for logged-in customers
 *   upgrade  failures and checkout intent, so those sessions are always kept
 *   cart     _clarity_session / _clarity_user / _clarity_recording attributes, so
 *            an order or abandoned checkout in Shopify Admin links to its recording
 *
 * Purely observational: it never cancels, delays or alters a request or a click,
 * and every hook is wrapped so a failure here cannot break the page.
 */
(function () {
  'use strict';
  if (window.__fitazClarityEnrich) return;
  window.__fitazClarityEnrich = true;

  var PROJECT = 'otnp3czzks';
  var OWN_HEADER = 'X-Fitaz-Clarity';
  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('fitaz-clarity-enrich-config').textContent) || {};
  } catch (e) {}

  // Standard Clarity queue stub: calls made before the tag loads are replayed by it.
  if (typeof window.clarity !== 'function') {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  }

  function c() {
    try {
      window.clarity.apply(window, arguments);
    } catch (e) {}
  }
  function tag(key, value) {
    if (value === undefined || value === null || value === '') return;
    c('set', key, String(value).slice(0, 100));
  }
  var fired = {};
  function evt(name, opts) {
    c('event', name);
    if (opts && opts.upgrade) c('upgrade', name);
    fired[name] = Date.now();
  }
  function safe(fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (e) {}
    };
  }
  function pathOf(url) {
    try {
      return new URL(url, location.origin).pathname.replace(/\/+$/, '');
    } catch (e) {
      return '';
    }
  }
  function urlOf(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }
  function hasOwnHeader(init) {
    var h = init && init.headers;
    if (!h) return false;
    if (typeof h.get === 'function') return !!h.get(OWN_HEADER);
    return !!h[OWN_HEADER];
  }

  /* ---------------------------------------------------------------- tags */

  var ua = navigator.userAgent || '';
  var inApp = /Instagram/i.test(ua) ? 'instagram'
    : /FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'facebook'
    : /\bGSA\//.test(ua) ? 'google'
    : /TikTok|musical_ly|BytedanceWebview/i.test(ua) ? 'tiktok'
    : 'none';
  var iosMatch = ua.match(/OS (\d+)_\d+(?:_\d+)? like Mac OS X/);
  var h = window.innerHeight || 0;

  tag('fz_market', cfg.market);
  tag('fz_currency', cfg.currency);
  tag('fz_host', /^au\./.test(location.hostname) || cfg.funnel ? 'funnel' : 'main');
  tag('fz_page', cfg.pageType);
  tag('fz_template', cfg.template);
  tag('fz_product', cfg.product);
  tag('fz_inapp', inApp);
  tag('fz_screen_h', h < 600 ? 'lt600' : h <= 740 ? '600-740' : 'gt740');
  if (iosMatch) tag('fz_ios', iosMatch[1]);
  tag('fz_customer', cfg.customerId ? 'logged_in' : 'guest');
  tag('fz_returning_buyer', cfg.returningBuyer);

  // Ad/campaign context arrives on the landing URL only; keep it for the session.
  safe(function () {
    var KEY = 'fz_clarity_attribution';
    var q = new URLSearchParams(location.search);
    var fresh = {
      ad_id: q.get('ad_id') || q.get('tw_adid') || '',
      campaign: q.get('campaign_id') || q.get('utm_campaign') || q.get('tw_campaign') || '',
      placement: q.get('tw_source') || '',
      utm_source: q.get('utm_source') || '',
      utm_medium: q.get('utm_medium') || ''
    };
    var stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem(KEY) || '{}');
    } catch (e) {}
    var any = Object.keys(fresh).some(function (k) { return fresh[k]; });
    var a = any ? fresh : stored;
    if (any) {
      try {
        sessionStorage.setItem(KEY, JSON.stringify(fresh));
      } catch (e) {}
    }
    tag('fz_ad_id', a.ad_id);
    tag('fz_campaign', a.campaign);
    tag('fz_placement', a.placement);
    tag('fz_utm_source', a.utm_source);
    tag('fz_utm_medium', a.utm_medium);
  })();

  function tagCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var value = (cart.total_price || 0) / 100;
    tag('fz_cart_items', String(cart.item_count || 0));
    tag('fz_cart_value', value === 0 ? '0' : value < 100 ? 'lt100' : value < 200 ? '100-199' : value < 300 ? '200-299' : '300+');
    tag('fz_cart_equipment', cart.items.some(function (i) {
      return /equipment/i.test((i.product_title || '') + ' ' + (i.title || ''));
    }) ? 'yes' : 'no');
  }

  /* ------------------------------------------------------------ identify */

  safe(function () {
    if (!cfg.customerId || !window.crypto || !crypto.subtle || !window.TextEncoder) return;
    crypto.subtle.digest('SHA-256', new TextEncoder().encode('fitaz:' + cfg.customerId)).then(function (buf) {
      var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('0' + b.toString(16)).slice(-2);
      }).join('').slice(0, 32);
      c('identify', hex);
    }).catch(function () {});
  })();

  /* ----------------------------------------- Clarity session onto the cart */

  var SYNC_KEY = 'fz_clarity_cart_session';
  var syncTimer = null;
  function getMeta(cb) {
    var done = false;
    try {
      window.clarity('metadata', function (d) {
        if (done || !d || !d.sessionId) return;
        done = true;
        cb(d);
      }, false, true, true);
    } catch (e) {}
  }
  function syncCartSession() {
    clearTimeout(syncTimer);
    // After the drawer has finished its own refresh, so this never races an add.
    syncTimer = setTimeout(safe(function () {
      getMeta(function (m) {
        var sig = m.userId + '/' + m.sessionId;
        try {
          if (sessionStorage.getItem(SYNC_KEY) === sig) return;
        } catch (e) {}
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        headers[OWN_HEADER] = '1';
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.item_count) return null;
            var attrs = cart.attributes || {};
            if (attrs._clarity_session === m.sessionId && attrs._clarity_user === m.userId) {
              try { sessionStorage.setItem(SYNC_KEY, sig); } catch (e) {}
              return null;
            }
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: headers,
              body: JSON.stringify({
                attributes: {
                  _clarity_session: m.sessionId,
                  _clarity_user: m.userId,
                  _clarity_recording: 'https://clarity.microsoft.com/player/' + (m.projectId || PROJECT) + '/' + m.userId + '/' + m.sessionId
                }
              })
            }).then(function (r) {
              if (r.ok) {
                try { sessionStorage.setItem(SYNC_KEY, sig); } catch (e) {}
              }
            });
          })
          .catch(function () {});
      });
    }), 1500);
  }

  /* --------------------------------------------------- add-to-cart outcome */

  var pendingClickAt = 0;
  var lastNetworkAddAt = 0;
  var lastCount = null;
  var noResponseTimer = null;

  function onAddResult(ok, status, description) {
    lastNetworkAddAt = Date.now();
    clearTimeout(noResponseTimer);
    if (ok) {
      evt('atc_success', { upgrade: true });
      syncCartSession();
    } else {
      tag('fz_atc_error', (status || 'network') + (description ? ': ' + description : ''));
      evt('atc_fail', { upgrade: true });
    }
  }

  function onCartMutation(pathname, bodyText) {
    if (/\/cart\/change(\.js)?$/.test(pathname) && /"quantity"\s*:\s*0\b|quantity=0\b/.test(bodyText || '')) {
      evt('cart_remove');
    }
  }

  // fetch: outermost wrapper; only reads a clone of the response.
  safe(function () {
    var prev = window.fetch;
    if (typeof prev !== 'function') return;
    window.fetch = function (input, init) {
      var p = prev.apply(this, arguments);
      try {
        if (hasOwnHeader(init)) return p;
        var path = pathOf(urlOf(input));
        if (/\/cart\/add(\.js)?$/.test(path)) {
          p.then(function (res) {
            if (res.ok) return onAddResult(true, res.status);
            res.clone().json().then(function (d) {
              onAddResult(false, res.status, d && (d.description || d.message));
            }).catch(function () { onAddResult(false, res.status); });
          }, function () { onAddResult(false, 'network'); });
        } else if (/\/cart\/(change|update)(\.js)?$/.test(path)) {
          onCartMutation(path, init && typeof init.body === 'string' ? init.body : '');
        }
      } catch (e) {}
      return p;
    };
  })();

  // XHR: same signal for anything still adding to cart via XMLHttpRequest.
  safe(function () {
    var XHR = window.XMLHttpRequest;
    if (!XHR) return;
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      try { this.__fzPath = pathOf(url || ''); } catch (e) {}
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      try {
        var xhr = this;
        var path = xhr.__fzPath || '';
        if (/\/cart\/add(\.js)?$/.test(path)) {
          xhr.addEventListener('loadend', function () {
            var s = Number(xhr.status) || 0;
            if (s >= 200 && s < 300) return onAddResult(true, s);
            var d = null;
            try { d = JSON.parse(xhr.responseText); } catch (e) {}
            onAddResult(false, s || 'network', d && (d.description || d.message));
          });
        } else if (/\/cart\/(change|update)(\.js)?$/.test(path)) {
          onCartMutation(path, typeof body === 'string' ? body : '');
        }
      } catch (e) {}
      return send.apply(this, arguments);
    };
  })();

  // The drawer can add through its own earlier fetch reference; its refresh event
  // is the backstop that still reports those adds.
  document.addEventListener('kozler:cart:refreshed', safe(function (e) {
    var d = e.detail || {};
    if (d.cart) tagCart(d.cart);
    var count = typeof d.count === 'number' ? d.count : null;
    if (count !== null && lastCount !== null && count > lastCount &&
        pendingClickAt && Date.now() - pendingClickAt < 10000 && Date.now() - lastNetworkAddAt > 5000) {
      clearTimeout(noResponseTimer);
      evt('atc_success', { upgrade: true });
      syncCartSession();
    }
    if (count !== null) lastCount = count;
  }));

  /* ---------------------------------------------------------------- clicks */

  var ATC_SELECTOR = [
    '[data-wlr-plan-atc]', '[data-wlr-atc]', '[data-peri-plan-cta]', '[data-peri-native-atc]',
    'form[action*="/cart/add"] [type="submit"]', 'form[action*="/cart/add"] button:not([type="button"])',
    'button[name="add"]', '[data-add-to-cart]', '[data-tbf-atc]'
  ].join(',');

  function textOf(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  document.addEventListener('click', safe(function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var loop = t.closest('a[href*="loop_subscriptions/checkout"]');
    if (loop) {
      evt('loop_checkout_click', { upgrade: true });
      return;
    }

    if (t.closest('[data-src-popup-close]')) { evt('popup_close'); return; }
    if (t.closest('[data-src-popup-cta]')) { evt('popup_cta'); return; }

    var drawerCheckout = t.closest('[id*="kozler-cart"] [data-checkout-button]');
    var pageCheckout = !drawerCheckout && t.closest('button[name="checkout"], input[name="checkout"], [data-checkout-button]');
    if (drawerCheckout || pageCheckout) {
      evt(drawerCheckout ? 'drawer_checkout_click' : 'cart_page_checkout_click', { upgrade: true });
      var at = location.href;
      setTimeout(function () {
        if (location.href === at && document.visibilityState === 'visible') {
          evt('checkout_nav_slow', { upgrade: true });
        }
      }, 8000);
      return;
    }

    if (t.closest('.kozler-oneclick__control, .kozler-oneclick__input, [data-wlr-equip]')) {
      evt('upsell_add');
      return;
    }

    var btn = t.closest('button, a, [role="button"]');
    if (btn && /start quiz/i.test(textOf(btn))) { evt('quiz_start'); return; }
    if (btn && /start my transformation/i.test(textOf(btn))) { evt('quiz_result_cta'); }

    var atc = t.closest(ATC_SELECTOR) ||
      (btn && /^(add to cart|start your reset)/i.test(textOf(btn)) ? btn : null);
    if (atc && !atc.disabled && atc.getAttribute('aria-disabled') !== 'true') {
      evt('atc_click');
      pendingClickAt = Date.now();
      clearTimeout(noResponseTimer);
      // A tap that never produces an add request or a cart change: the
      // "pressed add to cart, nothing happened" case.
      var clickedAt = pendingClickAt;
      noResponseTimer = setTimeout(function () {
        var answered = lastNetworkAddAt >= clickedAt ||
          (fired.atc_success || 0) >= clickedAt || (fired.atc_fail || 0) >= clickedAt;
        if (!answered) evt('atc_no_response', { upgrade: true });
      }, 8000);
    }
  }), true);

  /* ------------------------------------------------- drawer + popup + quiz */

  safe(function () {
    var wasOpen = document.body && document.body.classList.contains('kozler-cart-locked');
    new MutationObserver(safe(function () {
      var open = document.body.classList.contains('kozler-cart-locked');
      if (open && !wasOpen) {
        evt('drawer_open');
        syncCartSession();
      }
      wasOpen = open;
    })).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();

  safe(function () {
    var popup = document.querySelector('[data-src-popup]');
    if (!popup) return;
    var seen = false;
    var check = safe(function () {
      if (!seen && !popup.hidden) {
        seen = true;
        evt('popup_view');
      }
    });
    check();
    new MutationObserver(check).observe(popup, { attributes: true, attributeFilter: ['hidden'] });
  })();

  if (/^\/pages\/[a-z0-9-]+-type$/.test(location.pathname)) evt('quiz_result_view');

  /* -------------------------------------------------------------- js errors */

  var errCount = 0;
  function onError(msg) {
    if (errCount >= 3) return;
    errCount += 1;
    if (errCount === 1) tag('fz_js_error', msg);
    evt('js_error', { upgrade: true });
  }
  window.addEventListener('error', safe(function (e) {
    if (e && e.target && e.target !== window) return; // resource load errors, not script errors
    onError((e && e.message) || 'error');
  }));
  window.addEventListener('unhandledrejection', safe(function (e) {
    var r = e && e.reason;
    onError('promise: ' + ((r && (r.message || r)) || 'rejected'));
  }));

  /* ------------------------------------------------------- initial cart tags */

  safe(function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        tagCart(cart);
        lastCount = cart.item_count;
        if (cart.item_count) syncCartSession();
      })
      .catch(function () {});
  })();
})();
